var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 8.33333C1.66602 8.33333 3.33683 6.05685 4.69421 4.69854C6.05159 3.34022 7.92735 2.5 9.99935 2.5C14.1415 2.5 17.4993 5.85786 17.4993 10C17.4993 14.1421 14.1415 17.5 9.99935 17.5C6.5801 17.5 3.69527 15.2119 2.79249 12.0833M1.66602 8.33333V3.33333M1.66602 8.33333H6.66602",
    stroke: "#F04242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.111ab7c1d6981c1af13d597ea3a10b60.svg";
export { ForwardRef as ReactComponent };